<template>
    <div>
        <div class="indexcon">
            <banner :banner="bannerList"></banner>
        </div>

        <div class="notice flx jsc">
            <div class="innernotice flx alc jsb">
                <div class="newsLeft flx alc">
                    <img :src="$Localimg('laba.png')" style="width: 26px;height: 26px;margin-right: 12px;" alt="" />
                    <div style="width: 800px;">
                        <el-carousel height="80px" direction="vertical" :autoplay="true">
                            <el-carousel-item style="height: 80px;" v-for="item,index in newsList" :key="index">
                                <div class="innerTxt cursor" @click="tonewsDetail(item)" v-text="item.title"
                                    style="line-height: 80px;text-align: left;">
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
                <div class="lookMore cursor" @click="toNewsList">
                    查看更多
                </div>
            </div>
        </div>

        <div class="mains">
            <div class="mainCon">
                <div class="titles flx alc jsb">
                    <div class="titleft">
                        精选推荐
                    </div>
                    <img class="checkmopre cursor" @click="torecom" :src="$Localimg('checkmore.png')" alt="" />
                </div>

                <div class="relist flx">
                    <div class="reItem" @click="toDetail1(item)" v-for="item,index in recommand">
                        <div class="labelName" v-text="item.label" v-if="item.label">

                        </div>
                        <div class="reImg">
                            <img :src="$img(item.avatar)" alt="" />
                        </div>
                        <div class="reInfo">
                            <div class="reName multy2" v-text="item.name">

                            </div>
                            <div class="reTitle single" v-text="item.title">

                            </div>
                            <div class="flx" style="justify-content: flex-end;margin-top: 20px;">
                                <div class="rebtn" v-if="item.category_id == 2 && item.is_type == 3">
                                    马上预约
                                </div>
                                <div class="rebtn" v-if="item.category_id == 2 && item.is_type == 2">
                                    观看回放
                                </div>
                                <div class="rebtn" v-if="item.category_id == 2 && item.is_type == 1">
                                    了解课程
                                </div>
								<div class="rebtn" v-if="item.category_id == 2 && item.is_type == 4">
								    马上观看
								</div>
                                <div class="rebtn" v-if="item.category_id != 2 && item.category_id != 1">
                                    马上查看
                                </div>
								<div class="rebtn" v-if="item.category_id == 1 && (item.over_time >= item.current_time)">
								    马上报名
								</div>
								<div class="rebtn" style="background: #E0E0E0 !important" v-if="item.category_id == 1 && (item.over_time < item.current_time)">
								    活动已结束
								</div>
								
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="wbkcon">
                <div class="wbContent flx jsb">
                    <div class="wbLeft">
                        <div class="titles flx alc jsb">
                            <div class="titleft">
                                HR岗位推荐
                            </div>
                            <img class="checkmopre cursor" :src="$Localimg('checkmore.png')" alt=""
                                @click="tocates(2)" />
                        </div>
                        <div class="hrs">
                            <div class="hritem cursor" v-for="item,index in hrlist" @click="tohr(item)">
                                <div class="hrtop flx alc">
                                    <div class="hrname" v-text="item.name"></div>
                                    <div class="hrPrice" v-if="item.salary_mix > 0 && item.salary_max > 0"
                                        v-text="`${item.salary_mix}K ~ ${item.salary_max}K`"> </div>
                                    <div class="hrPrice" v-else>面议</div>
                                </div>
                                <div class="hrtitle flx alc">
                                    <div v-text="item.company_name"></div>
                                    <div v-text="`${item.company_people}`"></div>
                                </div>
                                <div class="hrlabels flx alc">
                                    <div class="hrlabel" v-text="item.exp_name" v-if="item.exp_name"></div>
                                    <div class="hrlabel" v-text="item.eb_name" v-if="item.eb_name"></div>
                                    <div class="hrlabel" v-text="item.company_label" v-if="item.company_label"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wbRight">
                        <div class="titles flx alc jsb">
                            <div class="titleft">
                                图书推荐
                            </div>
                            <img class="checkmopre cursor" :src="$Localimg('checkmore.png')" alt=""
                                @click="tocates(6)" />
                        </div>
                        <div class="booksContent">
                            <div class="bookItem cursor flx alc" :style="index == 4?'border:none': ''"
                                v-for="item,index in bookList" @click="togoodsdetail(item)">
                                <div class="bookImage">
                                    <img :src="$img(item.avatar)" alt="" />
                                </div>
                                <div class="bookInfo">
                                    <div class="bookName single" v-text="item.goods_name">

                                    </div>
                                    <div class="bookau" v-text="item.publisher_name.name">

                                    </div>
                                    <div class="bookprice flx alc jsb">
                                        <!-- <div class="bprice" v-text="`￥${item.default_goods_price}`">

                                        </div>
                                        <div class="sales" v-text="`已售${item.sales}部`">

                                        </div> -->
                                    </div>
                                    <div class="oprice" v-if="item.default_line_price * 1 > 0" v-text="`售价${item.default_line_price}`">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="wbContent">
                    <div class="coachs">
                        <div class="titles flx alc jsb">
                            <div class="titleft">
                                导师推荐
                            </div>
                            <img class="checkmopre cursor" :src="$Localimg('checkmore.png')" alt=""
                                @click="tocates(3)" />
                        </div>
                        <div class="coachers flx alc jsb">
                            <div class="coaitem" v-for="item,index in coaches" @click="tocao(item)">
                                <div class="coaImage">
                                    <img :src="$img(item.recom_avatar)" alt="" />
                                </div>
                                <div class="coaingo">
                                    <div style="margin-bottom: 10px;" class="flx alc jsb">
                                        <div class="coaname" v-text="item.name"></div>
                                        <el-button size="small" type="primary">马上查看</el-button>
                                    </div>

                                    <div class="coatitle single" v-text="item.title"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="mainCon" style="box-sizing: border-box;padding-bottom: 56px;">
                <div class="titles flx alc jsb">
                    <div class="titleft">
                        分类查找
                    </div>
                </div>

                <div class="cateList flx jsb">
                    <div class="cateItem cursor" v-for="item,index in cates" @click="goLink(item.pc_url)">
                        <img :src="$img(item.pc_avatar)" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getIndex,
        getRecommands
    } from "@/api/index.js"
    import banner from "@/components/banner.vue"

    export default {
        name: "index",
        components: {
            banner
        },
        data() {
            return {
                cates: [],
                bannerHeight: "500px", // 轮播高度自定义
                autoPlay: true,
                videoDialogVisible: false,
                currentVideoUrl: "",
                bannerList: [],
                newsList: [],
                recommand: [],
                hrlist: [],
                bookList: [],
                coaches: []
            };
        },
        created() {
            this.getIndex()
        },
        methods: {
            toNewsList() {
                this.$router.push({
                    path: '/newsList'
                })
            },
            tonewsDetail(e) {
                this.$router.push({
                    path: '/newsDetail', // 写路由path
                    query: {
                        id: e.id,
                    }
                })
            },
            torecom() {
                this.$router.push({
                    path: '/recommand'
                })
            },
            tocates(e) {
                let that = this
                that.activeIndex = e
                console.log(e)
                if (e == 0) {
                    this.$router.push({
                        path: '/acindex'
                    })
                }

                if (e == 1) {
                    this.$router.push('/Live')

                }

                if (e == 2) {
                    this.$router.push('/Recruitment')

                }

                if (e == 3) {
                    this.$router.push('/coach')

                }
                if (e == 4) {
                    this.$router.push('/certification')

                }

                if (e == 5) {
                    this.$router.push('/education')

                }

                if (e == 6) {
                    this.$router.push('/books')

                }

                if (e == 7) {
                    this.$router.push('/serviceIndex')

                }
            },
            toDetail1(e) {
                let that = this
                if (e.category_id == 1) {
                    this.$router.push({
                        path: '/signDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 2) {
                    this.$router.push({
                        path: '/liveDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 3) {
                    this.$router.push({
                        path: '/RecruitmentDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 4) {
                    this.$router.push({
                        path: '/coachDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 5) {
                    this.$router.push({
                        path: '/cerDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 6) {
                    this.$router.push({
                        path: '/eduDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 7) {
                    this.$router.push({
                        path: '/bookDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 8) {
                    this.$router.push({
                        path: '/serviceDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                }
            },
            tocao(e) {
                this.$router.push({
                    path: '/coachDetail', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            togoodsdetail(e) {
                this.$router.push({
                    path: '/bookDetail', // 写路由path
                    query: {
                        id: e.goods_id
                    }
                })
            },
            getIndex() {
                let that = this
                let data = {}
                data.page = 1
                data.size = 8
                getIndex().then((res) => {
                    if (res.code == 1) {
                        that.bannerList = res.data.banner
                        that.newsList = res.data.news
                        that.cates = res.data.icon_nav[0]
                    }
                })

                getRecommands(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.recommand = res.data.recom_list.data
                        that.hrlist = res.data.hr_list
                        that.bookList = res.data.book_list
                        that.coaches = res.data.mentor_list

                    }
                })

            },
            tohr(e) {
                this.$router.push({
                    path: '/RecruitmentDetail', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            // 点击图片跳转
            goLink(url) {
                // 判断是内部路由还是外部链接
                if (url.startsWith("http")) {
                    window.open(url, "_blank");
                } else {
                    this.$router.push(url);
                }
            },
            // 打开视频弹窗
            openVideoDialog(url) {
                this.currentVideoUrl = url;
                this.videoDialogVisible = true;
                // 打开视频时暂停轮播
                this.autoPlay = false;
            },
            // 关闭弹窗销毁视频，停止播放
            closeVideo() {
                this.currentVideoUrl = "";
                this.videoDialogVisible = false;
                // 关闭视频恢复自动轮播
                this.autoPlay = true;
            }
        }
    };
</script>
<style scoped>
    .labelName {
        height: 29px;
        background: linear-gradient(79deg, #F59E0B 0%, #F4870A 100%);
        border-radius: 15px 15px 15px 2px;
        box-sizing: border-box;
        padding: 0 11px;
        line-height: 29px;
        position: absolute;
        left: 12px;
        top: 12px;
        font-weight: 600;
        font-size: 13px;
        color: #FFFFFF;
    }

    .cateItem {
        width: 350px;
        height: 262px;
        border-radius: 8px;
        margin-bottom: 21px;
    }

    .cateList {
        flex-wrap: wrap;
    }

    .cateItem img {
        width: 100%;
        height: 100%;

    }

    .coaname {
        font-weight: 500;
        font-size: 18px;
        color: #222222;
        margin-bottom: 8px;
    }

    .coatitle {
        font-size: 14px;
        color: #999999;
    }

    .coaingo {
        box-sizing: border-box;
        padding: 20px;
        text-align: left;
    }

    .coaitem {
        width: 275px;
        /* height: 361px; */
        background: #FFFFFF;
        border-radius: 12px;
        overflow: hidden;
    }

    .coaImage {
        width: 275px;
        height: 268px;
    }

    .coaImage img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .bookprice {
        margin-bottom: 6px;
    }

    .oprice {
        font-size: 12px;
        color: #9CA3AF;
        font-size: 12px;
        color: #9CA3AF;
        text-decoration-line: line-through;
    }

    .bprice {
        font-weight: 600;
        font-size: 18px;
        color: #FF6A00;
    }

    .sales {
        font-size: 12px;
        color: #9CA3AF;
    }

    .bookName {
        width: 100%;
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 6px;

    }

    .bookau {
        font-weight: 500;
        font-size: 12px;
        color: #6B7280;
        margin-bottom: 19px;
    }

    .bookInfo {
        width: 224px;
        text-align: left;
    }

    .bookItem {
        box-sizing: border-box;
        padding: 16px 0;
        border-bottom: 1px solid #EDEDED;
    }

    .booksContent {
        box-sizing: border-box;
        padding: 0 20px;
        background: #fff;
    }

    .bookImage {
        width: 130px;
        height: 130px;
        border-radius: 12px;
        margin-right: 16px;
        flex-shrink: 0;
    }

    .bookImage img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .hrlabel {
        font-weight: 500;
        font-size: 12px;
        color: #374151;
        box-sizing: border-box;
        padding: 6px 16px;
        background: #F3F4F6;
        border-radius: 15px;
        margin-right: 14px;
    }

    .hrtop {
        margin-bottom: 18px;
    }

    .hrtitle div {
        margin-right: 20px;
    }

    .hrtitle {
        font-size: 14px;
        color: #4B5563;
        margin-bottom: 18px;
    }

    .hrname {
        font-weight: 600;
        font-size: 28px;
        color: #000000;
        margin-right: 20px;
    }

    .hrPrice {
        font-weight: 600;
        font-size: 28px;
        color: #FF6A00;
    }

    .hritem {
        width: 100%;
        height: 184px;
        background: #FFFFFF;
        border-radius: 12px;
        box-sizing: border-box;
        padding: 30px 27px;
        margin-bottom: 30px;
    }

    .wbLeft .titles {
        margin-bottom: 27px;
    }

    .wbLeft {
        width: 1027px;

    }

    .wbRight {
        width: 400px;
    }

    .wbContent {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding-top: 56px;
    }

    .wbkcon {
        width: 100%;
        background: #F9FAFB !important;
        box-sizing: border-box;
        padding-bottom: 56px;
    }

    .reImg {
        width: 344px;
        height: 194px;
        overflow-y: hidden;
    }

    .reImg img {
        width: 100%;
    }

    .rebtn {
        width: 104px;
        height: 36px;
        background: linear-gradient(90deg, #4A9EFF 0%, #1E7FE5 100%);
        box-shadow: 0px 2px 6px 0px rgba(30, 127, 229, 0.25);
        border-radius: 18px;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        line-height: 36px;
        cursor: pointer
    }

    .reTitle {
        font-weight: 500;
        font-size: 14px;
        color: #9CA3AF;
        margin-top: 10px;
    }

    .reInfo {
        box-sizing: border-box;
        padding: 20px;
        text-align: left;
    }

    .reName {
        height: 48px;
        line-height: 24px;
        width: 100%;
        font-weight: 600;
        font-size: 16px;
        color: #000000;
    }

    .relist {
        flex-wrap: wrap;
        justify-content: space-between;
        box-sizing: border-box;
        padding-bottom: 56px;
    }

    .reItem {
        width: 344px;
        height: 372px;
        background: #FFFFFF;
        box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        margin-bottom: 28px;
        overflow: hidden;
        position: relative;
    }

    .titles {
        margin-bottom: 27px;
    }

    .checkmopre {
        width: 108px;
        /* height: 17px; */
    }

    .titleft {
        font-weight: 600;
        font-size: 30px;
        color: #000;
    }

    .mainCon {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding-top: 56px;
    }

    .mains {
        width: 100%;
        background: #fff;
    }

    .lookMore {
        font-weight: 600;
        font-size: 18px;
        color: #666666;
    }

    .innerTxt {
        font-size: 18px;
        font-weight: bold;
    }

    .innernotice {
        width: 1460px;
    }

    .notice {
        width: 100%;
        height: 60px;
        background: #F3F4F6;
        overflow: hidden
    }
</style>
